import React from 'react';
import { Switch } from 'react-router-dom';

import Home from '~/pages/Home';
import AutoLogin from '~/pages/AutoLogin';
import Dashboard from '~/pages/Dashboard';
import Events from '~/pages/Events';
import ManageEvent from '~/pages/Events/ManageEvent';
import Clients from '~/pages/Clients';
import Vouchers from '~/pages/Vouchers';
import Financial from '~/pages/Financial';
import Help from '~/pages/Help';
import Configurations from '~/pages/Configurations';
import Login from '~/pages/Login';
import UserList from '~/pages/Listings/Users';
import EventsList from '~/pages/Listings/Events';
import PaymentsList from '~/pages/Listings/Payments';
import TicketList from '~/pages/Listings/Tickets';
import ForgotPassword from '~/pages/ForgotPassword';
import Sponsors from '~/pages/Sponsors';
import NewSponsor from '~/pages/Sponsors/NewSponsor';
import UpdateSponsor from '~/pages/Sponsors/UpdateSponsor';
import ChangePassword from '~/pages/ChangePassword';
import Cancels from '~/pages/Cancels';
import CheckIn from '~/pages/CheckIn';
import Courtesy from '~/pages/Courtesy';
import Performance from '~/pages/Performance';
import Route from './Route';

const routes: React.FC = () => {
  return (
    <Switch>
      <Route path={`${process.env.PUBLIC_URL}/`} exact component={Login} />
      <Route
        path={`${process.env.PUBLIC_URL}/recuperar-senha`}
        exact
        component={ForgotPassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/alterar-senha/:token`}
        exact
        component={ChangePassword}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/auto-login/:token`}
        exact
        component={AutoLogin}
        both
      />
      <Route
        path={`${process.env.PUBLIC_URL}/inicio`}
        exact
        component={Home}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/dashboard`}
        exact
        component={Dashboard}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos`}
        exact
        component={Events}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/novo-evento`}
        exact
        component={ManageEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/editar-evento/:slug`}
        exact
        component={ManageEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/eventos/:slug/resumo`}
        exact
        component={ManageEvent}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/clientes`}
        exact
        component={Clients}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cupons`}
        exact
        component={Vouchers}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/financeiro`}
        exact
        component={Financial}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/ajuda`}
        exact
        isPrivate
        component={Help}
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/usuarios`}
        exact
        component={UserList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/eventos`}
        exact
        component={EventsList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/pedidos`}
        exact
        component={PaymentsList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/listagens/inscricoes`}
        exact
        component={TicketList}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/configuracao`}
        exact
        component={Configurations}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/patrocinadores`}
        exact
        component={Sponsors}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/patrocinadores/novo-patrocinador`}
        exact
        component={NewSponsor}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/patrocinadores/editar-patrocinador/:sponsor_id`}
        exact
        component={UpdateSponsor}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cancelamentos`}
        exact
        component={Cancels}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/check-in`}
        exact
        component={CheckIn}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/cortesia`}
        exact
        component={Courtesy}
        isPrivate
      />
      <Route
        path={`${process.env.PUBLIC_URL}/performance`}
        exact
        component={Performance}
        isPrivate
      />
    </Switch>
  );
};

export default routes;
